import {Component} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {UrlService} from "./service/url.service";
import {LoginIdService} from "./service/login-id.service";
import {authCodeFlowConfig} from "./init/keycloak-init.factory";
import {OAuthErrorEvent, OAuthService} from "angular-oauth2-oidc";
import {AuthService} from "./service/auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  isLoaded: boolean = false;
  title = 'app';
  currentURL: string;
  previousURL: string;
  showHeader: boolean = true;
  showFooter: boolean = true;

  constructor(private router: Router, private urlService: UrlService, private loginIdService: LoginIdService, private oauthService: OAuthService, private authService: AuthService) {

    this.oauthService.events.subscribe(e => {
      if(e instanceof OAuthErrorEvent){
        console.error(e);
        if(e.type === "token_refresh_error"){
          authService.logout();
        }
      } else {
        console.log(e)
      }
    });
    this.oauthService.setupAutomaticSilentRefresh();
    this.oauthService.configure(authCodeFlowConfig);
    this.authService.runInitialLoginSequence();
  }


  ngOnInit() {
    window.onmessage = (event) => {
      if (event.data === "showHeader")
        this.showHeader = true;
      if (event.data === "hideHeader") {
        this.showHeader = false;
        console.log("hiding header");
      }
      if (event.data === "showFooter")
        this.showFooter = true;
      if (event.data === "hideFooter")
        this.showFooter = false;
    };

    this.router.events.subscribe(
        event => {
          if (event instanceof NavigationStart) {
            this.isLoaded = true;
          } else if (event instanceof NavigationEnd) {
            this.isLoaded = false;
            this.previousURL = this.currentURL;
            this.currentURL = event.url;
            this.urlService.setPreviousUrl(this.previousURL);
          }
        },
        () => {
          this.isLoaded = false;
        })
  }

  isRouterUrlNewOrder() {
    return this.router.url === '/new_order';
  }
}
